import {
	IGetModifierRestaurantPropertiesArguments,
	IUpdateModifierRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForModifier,
	ICreateModifier,
	ICreateModifierV2,
	IUpdateModifier,
	IUpdateModifierV2,
	IGetPaginatedModifiers,
	IGetPaginatedModifiersByCustomerV2,
	IGetPaginatedModifiersByRestaurantV2,
	IGetModifierRestaurantPortionsArguments,
	IUpdateModifierPositions,
} from 'types';
import {
	serviceGetModifierInfo,
	serviceGetModifierInfoV2,
	serviceGetModifierRestaurantProperties,
	serviceUpdateModifierRestaurantProperties,
	serviceUpdateModifierRestaurantPropertiesAsPatch,
	serviceCreateModifier,
	serviceCreateModifierV2,
	serviceUpdateModifier,
	serviceUpdateModifierV2,
	serviceGetPaginatedModifiers,
	serviceGetPaginatedModifiersByCustomerV2,
	serviceGetPaginatedModifiersByRestaurantV2,
	serviceDeleteModifier,
	serviceDeleteModifierV2,
	serviceGetModifierPositionList,
	serviceUpdateModifierPositions,
	serviceUpdateRestaurantsInModifier,
	serviceGetModifierPortionInfo,
	serviceGetModifierRestaurantPortions,
	serviceGetModifierPhotos,
} from 'services/api/modifiers';
import { createAppErrorMessage } from 'utils/helpers';

// Menu v1
const getModifierInfo = async (modifierID: string) => {
	try {
		const response = await serviceGetModifierInfo(modifierID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1

// Menu v2
const getModifierInfoV2 = async (modifierID: string) => {
	try {
		const response = await serviceGetModifierInfoV2(modifierID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getModifierRestaurantProperties = async (args: IGetModifierRestaurantPropertiesArguments) => {
	try {
		const response = await serviceGetModifierRestaurantProperties(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateModifierRestaurantProperties = async (args: IUpdateModifierRestaurantProperties) => {
	try {
		await serviceUpdateModifierRestaurantProperties(args);
	} catch (err) {
		throw err;
	}
};

const updateModifierRestaurantPropertiesAsPatch = async (data: IUpdateRestaurantPropertiesAsPatchForModifier) => {
	try {
		await serviceUpdateModifierRestaurantPropertiesAsPatch(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurantPropertiesAsPatch');
		throw new Error(errorMessage);
	}
};

// Menu v1
const createModifier = async (data: ICreateModifier) => {
	try {
		await serviceCreateModifier(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1

// Menu v2
const createModifierV2 = async (data: ICreateModifierV2) => {
	try {
		const response = await serviceCreateModifierV2(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingModifier');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const updateModifier = async (data: IUpdateModifier) => {
	try {
		await serviceUpdateModifier(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1

// Menu v2
const updateModifierV2 = async (data: IUpdateModifierV2) => {
	try {
		const response = await serviceUpdateModifierV2(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifier');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getPaginatedModifiers = async (args: IGetPaginatedModifiers) => {
	try {
		const response = await serviceGetPaginatedModifiers(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1

// Menu v2
const getPaginatedModifiersByCustomerV2 = async (args: IGetPaginatedModifiersByCustomerV2) => {
	try {
		const response = await serviceGetPaginatedModifiersByCustomerV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getPaginatedModifiersByRestaurantV2 = async (args: IGetPaginatedModifiersByRestaurantV2) => {
	try {
		const response = await serviceGetPaginatedModifiersByRestaurantV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const deleteModifier = async (modifierID: string) => {
	try {
		await serviceDeleteModifier(modifierID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingModifier');
		throw new Error(errorMessage);
	}
};
// Menu v1

// Menu v2
const deleteModifierV2 = async (modifierID: string) => {
	try {
		await serviceDeleteModifierV2(modifierID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingModifier');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getModifierPositionList = async (modifierGroupId: string) => {
	try {
		const response = await serviceGetModifierPositionList(modifierGroupId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateModifierPositions = async (data: IUpdateModifierPositions) => {
	try {
		await serviceUpdateModifierPositions(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifierPositions');
		throw new Error(errorMessage);
	}
};

const updateRestaurantsInModifier = async (data: { modifierId: string; restaurantIds: string[] }) => {
	try {
		await serviceUpdateRestaurantsInModifier(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingRestaurant');
		throw new Error(errorMessage);
	}
};

const getModifierPortionInfo = async (portionId: string) => {
	try {
		const response = await serviceGetModifierPortionInfo(portionId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getModifierRestaurantPortions = async (args: IGetModifierRestaurantPortionsArguments) => {
	try {
		const response = await serviceGetModifierRestaurantPortions(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getModifierPhotos = async (args: { ids: string[]; size: 1 | 2 | 3 }) => {
	try {
		const response = await serviceGetModifierPhotos(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

export {
	getModifierInfo,
	getModifierInfoV2,
	getModifierRestaurantProperties,
	updateModifierRestaurantProperties,
	updateModifierRestaurantPropertiesAsPatch,
	createModifier,
	createModifierV2,
	updateModifier,
	updateModifierV2,
	getPaginatedModifiers,
	getPaginatedModifiersByCustomerV2,
	getPaginatedModifiersByRestaurantV2,
	deleteModifier,
	deleteModifierV2,
	getModifierPositionList,
	updateModifierPositions,
	updateRestaurantsInModifier,
	getModifierPortionInfo,
	getModifierRestaurantPortions,
	getModifierPhotos,
};
